<div
    [@fadeIn]="fadeInAnimationState"
    (@fadeIn.done)="whenFadeInDone($event)"
    class="grid-container"
    [class.hero-product]="isGridHeroProduct"
    [class.list]="displayMode === 'list' && isMobile"
    #gridResultsUl>
    @for (item of resultItems; track trackById(i, item); let i = $index) { @if (isGridProduct(item)) {
    <div [id]="getItemId(item)" class="product-grid-list-item" data-cs-override-id>
        <h-grid-result-item
            [isListMode]="displayMode === 'list'"
            [product]="item"
            [index]="i"
            [isSearchGrid]="isSearchGrid"
            [editosDisplayed]="editos.length"
            [gridChange$]="gridRendered$.asObservable()"
            [isMobile]="isMobile"
            [isVtoDisplayed]="(isVtoEnabled$ | async) === true && (item.isVto || item.vtoType !== undefined)">
        </h-grid-result-item>
    </div>
    } @if (!isGridProduct(item)) {
    <h-grid-edito [id]="getItemId(item)" class="grid-result-edito" [edito]="item" [isEvenEdito]="isEvenEdito(item)">
    </h-grid-edito>
    } }
</div>

<div class="grid-result-footer">
    <h-grid-result-footer> </h-grid-result-footer>
</div>

@if (seoText$ | async; as seoText) {
<div>
    <div class="separator"></div>
    <h-grid-seo-text [text]="seoText"></h-grid-seo-text>
</div>
}
